import { AbstractSource } from "../../../../base/infrastructure/drawing";
import { IContentSource } from "../../../../base/domain/drawing";

export class EditableFormatThumbnailImageSource extends AbstractSource {
  constructor(getToken: () => string, public formatId: number, public key: number) {
    super(getToken);
  }

  protected getSource(): string {
    const url = "/api/format-editor/format/" + this.formatId + "/thumbnail/" + this.key + "?token=" + this.token;
    console.debug("[Source] " + url);
    return url;
  }

  public clone(): IContentSource {
    return new EditableFormatThumbnailImageSource(
      this._getToken,
      this.formatId,
      this.key
    );
  }
}
